import React from "react";
import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
import TopTabs from "../../components/Super Admin/TopBar/TopbarCoreFunctions";
import StationManagementTable from "../../components/Super Admin/Core Functions/StationManagementTable";
// import "../css/StationManagementPage.css";
import "../../css/FormsPage.css";


const StationManagementPage: React.FC = () => {
  return (
    <>
        <TopTabs />
        <StationManagementTable />
    </>
  );
};

export default StationManagementPage;
